module.exports = __webpack_public_path__ + "img/aball1_ks1.4b6cde86.png";